import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { OrganizationService } from 'src/app/core/service/organization.service';

@Injectable({
    providedIn: 'root'
})
export class OrganizationValidators
{
    constructor(private organizationService: OrganizationService) { }

    public validateOrganizationNameUnique(control: UntypedFormControl, initialOrganizationName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialOrganizationName !== control.value)
            {
                this.organizationService.existsOrganizationName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }

        });
    }

    public validateOrganizationKeyUnique(control: UntypedFormControl, organizationId: number, extensionId: number, category: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && control.value !== '' && category !== null)
            {
                this.organizationService.existsSettingExtension(control.value, organizationId, category).subscribe({
                    next: (response) =>
                    {
                        if (response !== null && response.id !== extensionId)
                        {
                            resolve({ keyExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }

        });
    }
}
